import { _ as me, a as A } from "./index-ebdb31f7.js";
import { _ as ve } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as W } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.replace-f4cc3aea.js";
import { useTheme as Pe, ThemeName as fe } from "@ucl/shared-component-foundations";
import { useCustomTranslation as he } from "@ucl/ucl-translation";
import { c as be } from "./index-8b07dec9.js";
import I, { useRef as ye } from "react";
import { styled as q, css as z } from "styled-components";
import { a as B } from "./index-5d0f31c6.js";
import { T as Ie } from "./index-f5b44da3.js";
import { g as ge, f as g, v as Y, T as Ce, a as Te, b as De, c as ke } from "./localeLanguages-75ceae62.js";
import { jsx as v } from "react/jsx-runtime";
var Se = ["value", "onChange", "inputId", "isDisabled", "inputPlaceholder", "dateFormatOptions", "inputClassName", "autoSelect", "editable", "inputName", "formatInputText", "locale", "isRequired", "labelProp", "infoProp", "trailingText", "textSize", "helperTextProp", "inputState", "hideClearButton", "closeCalendar"], K, L, xe = q.div(K || (K = W([`
  &.DatePicker__Input {
    `, `;
  }
`])), function(e) {
  var s = e.theme.components.datePicker;
  return z(s.StyledCalendarPickerInput);
}), Ne = q.div(L || (L = W([`
  &.DatePicker__Input--iconWrapper {
    `, `;
  }
`])), function(e) {
  var s = e.theme.components.datePicker;
  return z(s.StyledIconWrapper);
}), We = /* @__PURE__ */ I.forwardRef(function(e, s) {
  var P = e.value, n = e.onChange, G = e.inputId, C = e.isDisabled, c = C === void 0 ? !1 : C, M = e.inputPlaceholder, T = e.dateFormatOptions, U = e.inputClassName, D = e.autoSelect, H = e.editable, J = e.inputName, k = e.formatInputText, S = e.locale, Q = e.isRequired, x = e.labelProp, y = x === void 0 ? {} : x, X = e.infoProp, Z = e.trailingText, N = e.textSize, d = e.helperTextProp, ee = e.inputState, _ = e.hideClearButton, ae = _ === void 0 ? !1 : _, i = e.closeCalendar, te = ve(e, Se), ne = he("DatePicker"), f = ne.t, R = I.useState(""), h = R[0], b = R[1], E = I.useState(!1), re = E[0], F = E[1], O = ge(P), V = ye(null), $ = function(u) {
    if (u === void 0 && (u = !0), k)
      return k();
    switch (O) {
      case De:
        return ke(T, S, P, u);
      case Ce:
        return Te(T, S, f("from"), f("to"), P);
    }
  }, oe = M, le = y == null ? void 0 : y.label, ie = Pe(), ue = ie.themeName === fe.FORD_PRO ? "cancelCloseFilled" : "cancelClose", m = !!(H && O === "SINGLE_DATE"), pe = function() {
    n == null || n(void 0), i == null || i();
  }, se = function() {
    var u, j;
    return /* @__PURE__ */ v(xe, {
      className: be(["DatePicker__Input", "DatePicker__Input--" + (N || "medium"), {
        "DatePicker__Input--disabled": c
      }, {
        "DatePicker__Input--editable": m
      }]),
      children: /* @__PURE__ */ v(Ie, Object.assign({
        startAdornmentProp: {
          startAdornment: /* @__PURE__ */ v(B, {
            icon: "calendar",
            "aria-hidden": "true"
          })
        },
        endAdornmentProp: {
          endAdornment: !c && !ae && P && n ? /* @__PURE__ */ v(Ne, {
            className: "DatePicker__Input--iconWrapper",
            onFocus: function(a) {
              a.stopPropagation(), a.preventDefault();
            },
            children: /* @__PURE__ */ v(B, {
              icon: "" + ue,
              role: "button",
              "aria-label": "Clear Button",
              size: "s",
              onClick: pe,
              className: "DatePicker__Input--icon",
              tabIndex: c ? -1 : 0,
              onKeyDown: /* @__PURE__ */ function() {
                var r = me(/* @__PURE__ */ A.mark(function a(o) {
                  var l;
                  return A.wrap(function(t) {
                    for (; ; )
                      switch (t.prev = t.next) {
                        case 0:
                          if (!(o.code === "Enter" || o.code === "Space")) {
                            t.next = 5;
                            break;
                          }
                          return n(void 0), t.next = 4, b("");
                        case 4:
                          (l = V.current) == null || l.focus();
                        case 5:
                        case "end":
                          return t.stop();
                      }
                  }, a);
                }));
                return function(a) {
                  return r.apply(this, arguments);
                };
              }()
            })
          }) : void 0
        },
        "data-testid": "datepicker-input",
        readOnly: !m,
        ref: s,
        inputRef: V,
        id: G,
        type: "text",
        value: m && re ? h : $(),
        onFocus: function(a) {
          a.stopPropagation(), b(m && h || $(!1) || ""), F(!0);
        },
        onBlur: function() {
          b(""), F(!1);
        },
        onInput: function(a) {
          var o = a.target.value, l = o.replace(/[^0-9/]/g, "");
          if (b(g(l)), D && Y(l)) {
            var p = g(l, !0), t = p.month, ce = p.day, de = p.year;
            n == null || n({
              month: +t,
              day: +ce,
              year: +de
            });
          }
        },
        onKeyDown: function(a) {
          if (a.code === "Enter") {
            if (m && !D && Y(h)) {
              var o = g(h, !0), l = o.month, p = o.day, t = o.year;
              n == null || n({
                month: +l,
                day: +p,
                year: +t
              });
            }
            i && (i == null || i()), a.stopPropagation();
          }
        },
        onKeyUp: function(a) {
          a.stopPropagation();
        },
        onClick: function() {
          !c && (i == null || i());
        },
        name: J,
        placeholder: f("MM / DD / YYYY", "placeholder", oe),
        disabled: c,
        className: U,
        helperTextProp: d,
        inputState: ee,
        required: Q,
        textSize: N,
        labelProp: Object.assign({}, y, {
          label: f("Select Date", "labelProp.label", le)
        }),
        "aria-labelledby": (d == null || (u = d.defaultProp) == null ? void 0 : u.id) + " " + (d == null || (j = d.secondaryProp) == null ? void 0 : j.id),
        infoProp: Object.assign({}, X),
        trailingText: Z
      }, te))
    });
  };
  return se();
});
export {
  We as C
};
